import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList} from 'angularfire2/database';
import * as firebase from 'firebase/app';
import { IOption } from 'ng-select';
@Injectable()
export class CompanyService {
    departmentHeads : AngularFireList<any>;
    departments:any;
    departmentsOptions:Array<IOption>;
  constructor(private firebase : AngularFireDatabase) {
      this.getAllDepartments();
   }
getDepartmentHeads()
{
  this.departmentHeads = this.firebase.list('departmentHeads');
  return this.departmentHeads;
}
getAllDepartments()
{
    this.firebase.list('departments').snapshotChanges().subscribe((data)=>{
        this.departments = [];
        this.departmentsOptions = [];
        data.forEach(element=>{
            var y = element.payload.toJSON();
            y["$key"] = element.key;
            this.departments.push(y);
            this.departmentsOptions.push({label: String(element.payload.child("name").val()),value: String(element.key)})
        });
    });
}
getDepartment(id)
{
    //return this.firebase.list('departments', ref=> ref.orderByKey().equalTo(id));
    var rootRef = firebase.database().ref('departments');
    return rootRef.child(id);
}

getAllDesignations()
{
    return this.firebase.list('designations');
}
getDesignation(id)
{
    var rootRef = firebase.database().ref('designations');
    return rootRef.child(id);
}

getAllAssets()
{
    return this.firebase.list('assets');
}

getAllLeaves()
{
    return this.firebase.list('leaves');
}

getCurrency()
{
    return firebase.database().ref("settings").child("general");
}
get department()
{
 return this.departments;
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/shared/company.service.ts